import { Application, InteractionManager } from "pixi.js";
import { singleton } from "tsyringe";
import { Stage } from "@pixi/layers";

@singleton()
export class PixiApp extends Application {
  constructor() {
    super({
      backgroundColor: 0x000000,
      antialias: false,
      view: document.getElementById("root") as HTMLCanvasElement,
      width: window.innerWidth,
      height: window.innerHeight,
      autoDensity: true,
      resolution: window.devicePixelRatio,
    });
    this.stage = new Stage();
    window.addEventListener("resize", this.onResize);
    const int: InteractionManager = this.renderer.plugins.interaction;
    // fix pixi interaction bug, without it mouseover/mouseout events don't work when opening 
    // app in new browser tab. after reloading the page it works fine! fucking hell
    // @ts-ignore
    int.onPointerOver(
      new MouseEvent("mouseover", {
        clientX: 0,
        clientY: 0,
        screenX: 0,
        screenY: 0,
      })
    );
  }
  private onResize = () => {
    this.renderer.resize(window.innerWidth, window.innerHeight);
  };
}
